import _ from 'lodash';
import React, { useEffect, useState, useMemo } from 'react';
import List from '@mui/material/List';
import { useLocation } from 'react-router-dom';

import { menus } from './menu';
import MenuItem from './MenuItem';
import { useSelector } from 'react-redux';

/*
const adminGroup = [
  { usrUuid: 'A36D8313-1EFE-4DC0-B212-5FE4D2BFE2FE', usrNm: '김경운' },
  { usrUuid: '54B38B51-8FCE-4301-87C3-7220A561DCA5', usrNm: '홍은주' },
  { usrUuid: 'd6d61c9c-7333-4369-b529-bbbbcb43a9d7', usrNm: '원유진' },
  { usrUuid: '157f0fc1-69f3-4a22-8b0b-05f4ed0e2e6b', usrNm: '김춘호' },
  { usrUuid: '9A64EA44-3348-4144-B796-6C6537581E65', usrNm: '박형석' },
  { usrUuid: 'e3e1a566-0e65-11ec-b577-f220cd7628ac', usrNm: 'admin' },  
];
*/
const MenuList = ({handleDrawerClose}) => {
  const { user } = useSelector(({ auth }) => ({
    user: auth.user,
  }));
  
  const { pathname } = useLocation();

const userMenu = useMemo(() => {
  // 유저 정보 내부의 menuAuthMapping 리스트에서 menuCode만 뽑아 배열로 만듭니다. (예: ['100', '200', '300'])
  const userMenuCodes = user?.menuAuthMapping?.map(mapping => String(mapping.menuCode)) || [];

  const filteredMenus = menus
    // 💡 1. 상위 메뉴 중 admin 메뉴 제외 복원
    .filter(menu => !menu.admin) 
    // 2. 유저가 권한을 가진 상위 메뉴만 필터링
    .filter(menu => userMenuCodes.includes(String(menu.id))) 
    .map(menu => ({
      ...menu,
      // 💡 3. 하위 아이템이 있다면 하위 admin 제외 복원 및 배열 스프레드로 온전히 복제
      items: menu.items 
        ? menu.items.filter(item => !item.admin)
        : []
    }));

  return filteredMenus;
}, [menus, user]);


  const [filterMenus, setFilterMenus] = useState([]);

  /*
    100 : 경영정보, 200 : 목표관리, 300 : 영업활동관리, 400 : 포캐스팅 관리, 500 : 수주 관리, 600 : 거래처/제품 관리
    , 700 : 세금계산서 관리, 800 : 채권/채무 관리, 900 : 결산관리, 1000 : 예산 관리, 1100 : 인사관리, 1200 : 총무관리, 1300 : 공통관리
    , 1400 : 기술활동관리
  */
  useEffect(() => {
    if (user) {
      // 마스터 어드민 그룹 배열 선언
      const ALLOWED_ADMIN_USERS = [
        'e3e1a566-0e65-11ec-b577-f220cd7628ac', 
        '9A64EA44-3348-4144-B796-6C6537581E65'  
      ]; 

      // 마스터 어드민 배열에 포함되면 전체 원본 menus를 깊은 복사, 아니면 admin 필터링이 끝난 userMenu를 깊은 복사합니다.
      let updatedMenus = (user.adminRole === 'Y' && ALLOWED_ADMIN_USERS.includes(user.usrUuid)) 
        ? _.cloneDeep(menus) 
        : _.cloneDeep(userMenu);

      // 💡 2. 특정 유저 체크 후 '고객실적현황' 제외 로직
      const EXCLUDE_TARGET_USER = 'BBB839D7-8193-4C29-96FC-527EE239FB8A'; 
      if (user.dptInf?.parentDptUuid === EXCLUDE_TARGET_USER) {
        updatedMenus = updatedMenus.map(menu => ({
          ...menu,
          // 하위 아이템 중 link가 'clientPerformanceStat'이 아닌 것만 남김
          items: menu.items ? menu.items.filter(item => item.link !== 'clientPerformanceStat') : []
        }));
      }

      setFilterMenus(updatedMenus);
    }
  }, [user, userMenu]);

  const activeMenus = useMemo(() => {
    return filterMenus.map(menu => {
      // includes 대신 정확한 경로 매칭을 사용하여 중복 활성화 방지
      const isOpen = menu.items?.some(item => {
        const itemPath = `/${item.link}`;
        
        return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
      });

      return {
        ...menu,
        defaultOpen: isOpen
      };
    });
  }, [filterMenus, pathname]);
  // -------------------------------------------------------

  return (
    <List
      sx={{ width: '100%', bgcolor: '#fafafa', color: '#424242' }}
      component="nav"
    >
      {activeMenus.map((menu, index) => {
        return (
          <MenuItem 
            handleDrawerClose={handleDrawerClose} 
            menu={menu} 
            key={index} 
            defaultOpen={menu.defaultOpen} 
          />
        );
      })}
    </List>
  );
};

export default MenuList;
